<template>
    <div>

    <div class="modal-dialog" role="document">
      <div class="modal-content p-all-5">
        <validation-observer ref="form">
          <div class="alert alert-danger figma-alert" v-if="apiResponseError">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z"
                  fill="#F44336"/>
            </svg>
            <span class="danger-alert-text"> {{ apiResponseError }} </span>
          </div>

          <div class="col-md-12 text-center" v-if="isLoading"><img src="/pic/loading-4.gif"></div>
          <form v-else @submit.prevent="submit" autocomplete="off">

            <div class="modal-header new-design row justify-content-around align-items-center mobile-p-bottom-0">
              <div class="col-sm-10">
                <h5 v-if="! customerId" class="modal-title title-new-design pull-lift">Add new customer</h5>
                <h5 v-else class="modal-title title-new-design pull-lift">Edit customer</h5>
              </div>
              <div class="col-sm-2 close-x-position">
                <svg class="pull-right closeModal"
                     width="14"
                     height="14"
                     viewBox="0 0 14 14" fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                      @click="closeModal">
                  <path
                      d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
                      fill="#03A9F4"/>
                </svg>
              </div>
            </div>

            <div class="modal-body">
              <div class="form-inputs">
                  <!-- start type section -->
                  <div>
                    <p class="font-size-18 bold">
                      <span class="select-services-dropdown-title inputs-title">Customer type</span>
                    </p>
                  </div>
                  <div class="customer-type-btns">
                    <div class="btn-group btn-group-justified" role="group"
                         aria-label="Justified button group" v-if="apis && apis.constrains">
                      <div class="btn-group" v-for="(type, key) in apis.constrains.customerTypes"
                           v-on:click="selectBusinessType(key, type.id)">
                        <button type="button" :target-customer-type="key"
                                :class="{'businessType': true, 'btn btn-txt-color': true, 'active': type.active}">
                          {{ type.title }}
                        </button>
                      </div>
                    </div>
                  </div>
                  <validation-provider :rules="dataSubmit.customerType == 'commercial' ? 'required' : ''"
                                       :name="'business_name'" v-slot="{errors}">
                    <div class="row p-top-20" v-if="dataSubmit.customerType == 'commercial'">
                      <div class="col-md-12">
                        <label class="inputs-title">Business name</label>
                      </div>
                      <div class="col-md-12">
                        <input :class="{'business-name-new-input': true, 'form-group':true, 'has-error':errors.length}"
                               name="business_name" type="text" v-model="dataSubmit.businessName"/>
                        <span class="text text-danger error-label">{{ errors[0] }}</span>
                      </div>
                    </div>
                  </validation-provider>
                  <!-- end type section -->

                  <!-- start trading name input -->
                  <div class="row p-top-20 mobile-p-top-0" v-show="apis.constrains && apis.constrains.showTradingNames">
                    <div class="col-md-12">
                      <label class="inputs-title">Trading name</label>
                    </div>
                    <div class="col-md-12" id="trading-name-container">
                      <select-trading-name :trading_id="dataSubmit.tradingName" :styleCreateCustomer="true"></select-trading-name>
                    </div>
                  </div>
                  <!-- end trading name input -->

                  <!-- start contact section -->
                  <div class="p-top-5 mobile-m-top-35 cp-padding-top">
                    <div class="contact-boxes-container">
                      <contact-box
                          v-for="(contactBox, key) in dataSubmit.contactBoxes"
                          :key="key"
                          :index="key"
                          :dataSubmit="dataSubmit"
                          :validationErrors="validationErrors"
                          :contactBox="contactBox"
                          :contactBoxTemp="contactBoxTemp"
                          :countryData="apis && apis.constrains ? apis.constrains.country : ''"
                          :customerId="customerId"
                          v-on:deleteContactBoxEvent="deleteContactBox($event)">
                      </contact-box>
                    </div>
                  </div>
                  <!-- end contact section -->

                  <!-- start notes section -->
                  <div class="row m-top--20">
                      <div class="col-md-12" v-if="showNotesField || dataSubmit.notes">
                          <div>
                            <textarea class="form-control p-all-15" v-model="dataSubmit.notes"
                                  style="border-radius: 8px" placeholder="Add notes to customer"></textarea>
                          </div>
                      </div>

                      <div class="col-md-12 m-bottom-0" v-if="!showNotesField && ! dataSubmit.notes">
                          <div class="btn-group pull-right" >
                        <span data-toggle="dropdown" class="float-right" aria-expanded="false" @click="toggleNotesField" style="margin-top: 3px;">
                              <a href="#">
                                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                           xmlns="http://www.w3.org/2000/svg"> <path
                                          d="M11 5H9V9H5V11H9V15H11V11H15V9H11V5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"
                                          fill="#03A9F4"/> </svg>
                                  </a>
                       </span>
                              <span data-toggle="dropdown" aria-expanded="false" @click="toggleNotesField" class="select-services-dropdown-add-label float-right"><a href="javascript:;" style="text-decoration: none; font-family: 'Roboto';font-style: normal;font-weight: 600;font-size: 14px;line-height: 24px;color: #2E4051;">Add notes to customer &nbsp;&nbsp;</a></span>
                          </div>
                      </div>
                  </div>
                  <!-- end notes section -->

                  <!-- start attributes section -->
                  <div class="attributes-container" v-if="apis && apis.constrains && apis.constrains.customerAttributes">
                    <customer-attribute
                        v-for="(attribute, key) in apis.constrains.customerAttributes"
                        :attribute="attribute"
                        :key="key"
                        :dataSubmit="dataSubmit"
                        :constrains="apis.constrains"
                        :validationErrors="validationErrors"
                        :customerId="customerId">
                    </customer-attribute>
                  </div>
                  <!-- end date section -->

                  <!-- start country input  select -->
                  <div class="row p-top-8 mobile-p-top-0 mobile-p-bottom-0">
                      <div class="col-md-12 mobile-m-bottom-0">
                          <label class="inputs-title">Country</label>
                      </div>
                      <div class="col-md-12 mobile-p-bottom-0 mobile-m-bottom-0">
                          <select-countries :country-name="countryNameMethod()"  :country-code="countryCodeMethod()" :validationErrors="validationErrors"></select-countries>
                      </div>
                  </div>


                  <!-- start time zone input select -->
                  <div class="row p-top-8 mobile-p-top-0 mobile-p-bottom-0">
                    <div class="col-md-12 mobile-m-bottom-0">
                      <label class="inputs-title">Timezone</label>
                    </div>
                    <div class="col-md-12 mobile-p-bottom-0 mobile-m-bottom-0">
                        <select-time-zone v-model="dataSubmit.timeZone" :default-company="apis.constrains? apis.constrains.countryTimeZone : ''"  :validationErrors="validationErrors"></select-time-zone>
                    </div>
                  </div>

                  <!-- start Billing Address input  select-->
                  <div class="row p-top-20 align-items-center no-m-b-mobile">
                    <div class="col-md-12">
                      <label class="inputs-title">Billing address <i class="fa fa-map-marker fa-lg mobile-hidden" aria-hidden="true"></i></label>
                    </div>
                    <div class="col-md-12 mobile-p-bottom-0 mobile-m-bottom-0" id="address">
                      <input type="text" name="address" id="customer-autocomplete-popup" value=""
                             :class="{'input-new-design': true, 'form-group':true, 'text_field form-control auto pac-target-input': true}"
                             placeholder="Find address"
                             onfocus="initAutocomplete(apis.constrains.country.country_code, 0, 'customer-autocomplete-popup', 'address', true);" >
                      <div>
                        <a data-toggle="modal" href="javascript:void(0)" class="open_map" id="show_customer_map_modal_popup"
                           onclick=" let id = $(this).attr('id'); document.getElementById('popupi').scrollTop=0; show_Map_Admin(id)">
                          <h4 class="text-position text-position-mobile">Select location on map</h4>
                        </a>
                      </div>
                      <input type="hidden" name="lat" auto_fill="lat" v-model="dataSubmit.locationData.lat" value="" id="lat"/>
                      <input type="hidden" name="lon" auto_fill="lng" v-model="dataSubmit.locationData.lon" value="" id="lon"/>
                      <input type="hidden" name="unit_lot_number"  auto_fill="subpremise" v-model="dataSubmit.locationData.unit_lot_number" value=""  id="unit_lot_number"/>
                      <input type="hidden" name="street_number" auto_fill="street_number" v-model="dataSubmit.locationData.street_number" value="" id="street_number"/>
                      <input type="hidden" name="street_address" auto_fill="route" v-model="dataSubmit.locationData.street_address" value="" id="street_address"/>
                      <input type="hidden" name="suburb" auto_fill="locality" v-model="dataSubmit.locationData.suburb" value="" id="`suburb`"/>
                      <input type="hidden" name="state" auto_fill="state" v-model="dataSubmit.locationData.state" value="" id="state"/>
                      <input type="hidden" name="postcode" auto_fill="postal_code" v-model="dataSubmit.locationData.postcode" value="" id="postcode"/>
                        <input type="hidden" name="country" auto_fill="country" v-model="dataSubmit.locationData.country" id="country">
                    </div>
                  </div>
                  <!-- start Billing Address input  select -->
              </div>
            </div>

            <!-- submit form -->
            <div class="modal-footer new-design onFocusAddress">
              <div class="col-md-12">
                <button type="submit" class="btn btn-primary new-design" :disabled="loading" :class="{disabled:loading}">
                  <span v-if="!loading">Save</span>
                  <span v-else><i class="fa fa-spinner fa-spin"></i> Loading...</span>
                </button>
              </div>
            </div>
          </form>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>

import {extend, ValidationObserver, ValidationProvider} from 'vee-validate';
import {email, required} from 'vee-validate/dist/rules';
import ContactBox from "@/modules/Customer/components/CustomerContactBox.vue";
import CustomerAttribute from "@/modules/Customer/components/CustomerAttributes.vue";
import SelectTradingName from "@/modules/common/components/SelectTradingName.vue";
import {atLeastOneOptionSelected, verifyPhoneNumbers} from '@/modules/Fields/validations';
import Api from '../api/index.js';
import {EventBus} from "@/events/event-bus";
import SelectTimeZone from "@/modules/common/components/SelectTimeZone.vue";
import {getCustomerLocationData} from "@/events/sharedMethods";


email.message = 'This is invalid email'
required.message = 'This field is required'

extend('email', email);
extend('required', required);
extend('atLeastOneOptionSelected', atLeastOneOptionSelected)
require("notifyjs-browser/dist/notify");

export default {
  name: "CreateEditCustomer",
  props: {
      id: {
          type: String,
          default() {
              return 'create_edit_customer_popup'
          }
      },
      customerIdProp:null
  },
  components: {
    SelectTimeZone,
    ValidationProvider,
    ValidationObserver,
    ContactBox,
    CustomerAttribute,
    SelectTradingName
  },
  data() {
    return {
      customerId: this.customerIdProp,
      loading: false,
      isLoading: true,
      apis: { constrains: null },
      apiResponseError: '',
      validationErrors: {},
      contactBoxTemp: {
        nameInputs: [{title: null, first_name: null, last_name: null}],
        emailInputs: [{email: null}],
        mobileInputs: [{code: null, mobile: null, showCode: false}],
        phoneInputs: [{code: null, phone: null, showCode: false}],
        noteInput: null
      },
      locationDataTemp: {
        marker_label: null,
        suburb: null,
        lat: null,
        lon: null,
        postcode: null,
        street_number: null,
        state: null,
        street_address: null,
        country: null,
        unit_lot_number: null,
        property_type: null,
      },
      dataSubmitTemp: {
        customerType: null,
        customerTypeId: null,
        businessName: null,
        tradingName: null,
        timeZone: null,
        notes: null,
        fax: null,
        poBox: null,
        locationData: null,
        contactBoxes: [],
        country: [],
      },
      dataSubmit: null,
      showNotesField: false,
      countryCode:null,
    }
  },
  methods: {
    watchAddedAddressId(id) {
      this.$nextTick(function () {

        let element = document.querySelector(id);
        var observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === "attributes" && mutation.attributeName === "autocomplete" && element.getAttribute('autocomplete') !== "chrome-off") {
              element.setAttribute("autocomplete", "chrome-off");

            }
          });
        });

        observer.observe(element, {
          attributes: true //configure it to listen to attribute changes
        });
      })

    },
    submit() {
      this.loading = true;
      this.getLocationDataValues();
      this.formSubmit();
    },
    selectBusinessType(type, id) {
      this.dataSubmit.customerType = type;
      this.dataSubmit.customerTypeId = id;

      $(".businessType").each(function () {
          $(this).removeClass('active');
      });
      $("[target-customer-type=" + type + "]").addClass('active');
    },
    addContactBox() {
      if (this.dataSubmit.contactBoxes.length < 3) {
        this.dataSubmit.contactBoxes.push(JSON.parse(JSON.stringify(this.contactBoxTemp)));
      }
    },
    countryNameMethod(){
        return this.apis.constrains ?  this.apis.constrains.country.country_name : null;
    },
    countryCodeMethod(){
      return this.apis.constrains ?  this.apis.constrains.country.country_code : null;
    },
    deleteContactBox(contactBoxIndex) {
      this.dataSubmit.contactBoxes.splice(contactBoxIndex, 1);
    },
    getCustomerConstrains() {
      let vm = this;
      Api.getCustomerConstrains({customer_id: this.customerId}).then((data) => {
        //set constrains
        vm.apis.constrains = data.data;
        //reset values of dataSubmit for attributes of customer
        for (const attribute in vm.apis.constrains.customerAttributes) {

          let data = vm.apis.constrains.customerAttributes[attribute],
              id = data.attribute_id,
              name = `attribute_${id}`,
              value;

          if ([13, 15].includes(data.attribute_type_id)) {
            value = [];
          } else if (data.attribute_type_id == 11 && data.is_new) {
            value = data.min;
          } else if (data.attribute_type_id == 7) {
            value = "No";
          } else if (data.attribute_type_id == 12 || data.attribute_type_id == 14) {
            value = data.attributeValues[0].attribute_value_id;
          } else {
            value = null;
          }

          vm.dataSubmit[name] = value;
        }
        vm.contactBoxTemp.mobileInputs[0].code = data.data.country.country_key+"_"+data.data.country.country_name;
        vm.contactBoxTemp.phoneInputs[0].code = data.data.country.country_key+"_"+data.data.country.country_name;
        if (vm.customerId){
            vm.dataSubmit = vm.apis.constrains.dataSubmit;

            if (vm.dataSubmit.locationData){
              let line_address = '';
              if (vm.dataSubmit.locationData.unit_lot_number)
              {
                line_address += vm.dataSubmit.locationData.unit_lot_number;
                line_address += '/';
              }
              if (vm.dataSubmit.locationData.street_number)
              {
                line_address += vm.dataSubmit.locationData.street_number;
              }
              if (vm.dataSubmit.locationData.street_address)
              {
                line_address += ' ';
                line_address += vm.dataSubmit.locationData.street_address;
              }
              if (vm.dataSubmit.locationData.suburb)
              {
                line_address += ' ';
                line_address += vm.dataSubmit.locationData.suburb;
              }
              if (vm.dataSubmit.locationData.state)
              {
                line_address += ' ';
                line_address += vm.dataSubmit.locationData.state;
              }
              if (vm.dataSubmit.locationData.country)
              {
                line_address += ', ';
                line_address += vm.dataSubmit.locationData.country;
              }
              $("#customer-autocomplete-popup").val(line_address);
            }
        }
        let selectedTimeZone = null;
        if (vm.dataSubmit && vm.dataSubmit.timeZone){
            selectedTimeZone= vm.dataSubmit.timeZone;
        }else{
            selectedTimeZone = data.data.countryTimeZone;
        }
        if (vm.dataSubmit && vm.dataSubmit.timeZone == null){
          vm.dataSubmit.timeZone = data.data.countryTimeZone;
        }
          EventBus.$emit('timeZoneChanged', selectedTimeZone);
      });

    },
    getLocationDataValues() {
      for (const data in this.dataSubmit.locationData) {
        this.dataSubmit.locationData[data] = $("[name='" + data + "']").val();
      }
    },
    reBuildForm() {

      //reset selected radio and checkboxes
      $(".listSelected").find('li').removeClass('selected');

      //reset dataSubmit
      this.dataSubmit = JSON.parse(JSON.stringify(this.dataSubmitTemp));

      //reset location data
      this.dataSubmit.locationData = JSON.parse(JSON.stringify(this.locationDataTemp));
      $("#customer-autocomplete-popup").val('');

      this.resetSuccessErrorMessages();
        this.$nextTick(() => {
            //reset values of customer attributes
            this.getCustomerConstrains();
        })
      //add default Contact box
      this.addContactBox();

      //reset selection of business type and signature
      if(this.customerId){

        this.selectBusinessType(this.dataSubmit.customerType, this.dataSubmit.customerTypeId);
        EventBus.$emit('resetSignature', false);

      } else {

        this.selectBusinessType('residential', 66);
        EventBus.$emit('resetSignature', true);
      }
    },
    closeModal() {
        window.location.pathname == '/myAccountCustomer' ? this.apis.constrains.open_from = false : '';
        if (this.apis.constrains.open_from && window.location.pathname !== '/booking/add'){
          window.history.back();
        } else {
          let popupId = this.id;
          $('#' + popupId).modal('hide');
        }
        $('#country_code_from_customer').remove();
    },
    async verifyPhonesMobiles() {
      let response = true;
      for (const index in this.dataSubmit.contactBoxes) {
        for (const inputType in this.dataSubmit.contactBoxes[index]) {
          if (inputType == 'mobileInputs' || inputType == 'phoneInputs') {
            let type = inputType == 'mobileInputs' ? 'mobile' : 'phone';
            for (const key in this.dataSubmit.contactBoxes[index][inputType]) {
              let value = this.dataSubmit.contactBoxes[index][inputType][key][type] || '',
                  code =   this.dataSubmit  && this.dataSubmit.contactBoxes && this.dataSubmit.contactBoxes[index][inputType][key].code && this.dataSubmit.contactBoxes[index][inputType][key].code.length > 1 ? this.dataSubmit.contactBoxes[index][inputType][key].code.split("_")[0] : this.apis.constrains.country.country_key;
              if (value) {
                await verifyPhoneNumbers([value], code).then(data => {
                  if (!data.is_valid) {
                    response = false;
                    let fieldName = `${type}_${index}_${key}`;
                    this.validationErrors[fieldName] = data[0];
                    this.apiResponseError = data[0];
                  }
                });
              }
            }
          }
        }
      }

      return response;
    },
      verifyTimeZone(){
        if (! this.dataSubmit.timeZone){
            this.validationErrors['timezone'] = `please at least choose one`;
            return false;
        }

        return true;

      },
    verifyCustomerAttributes() {
      let response = true;
      for (const key in this.apis.constrains.customerAttributes) {
        let attribute = this.apis.constrains.customerAttributes[key];
        let value = this.dataSubmit[`attribute_${attribute.attribute_id}`];
        let mandatory = attribute.mandatory;
        let isNew = attribute.is_new;
        let attributeTypeId = attribute.attribute_type_id;
        let name = attribute.attribute_variable_name;

        if (attributeTypeId == 11 && isNew && mandatory && (value < attribute.min || value > attribute.max)) {
          this.validationErrors[name] = `this filed must be between { ${attribute.min} , ${attribute.max} }`;
          response = false;

        } else if ([13, 15].includes(attributeTypeId) && mandatory && (!value || value && !value.length)) {
          this.validationErrors[name] = `please at least choose one`;
          response = false;

        }
      }
      return response;
    },
    resetSuccessErrorMessages() {
      this.validationErrors = {};
      this.apiResponseError = null;
    },
    async formValidation() {
      //reset validation before new validation
      this.resetSuccessErrorMessages();
      let validateTimezone = this.verifyTimeZone();
      let validationAttributes = this.verifyCustomerAttributes();
      let validationPhonesMobiles = await this.verifyPhonesMobiles();
      let validationForm = await this.$refs.form.validate();
      return (validationAttributes && validationPhonesMobiles && validationForm && validateTimezone);
    },
    async formSubmit() {

      let vm = this;
      let formValidation = await this.formValidation();

      if (!formValidation) {
        this.apiResponseError = !this.apiResponseError ? 'Please check form required data' : this.apiResponseError;
        this.loading = false;
        $("#" + this.id).animate({scrollTop: 0}, 'slow');
      } else {

          let API;

          //ADD CUSTOMER
          if(! this.customerId){
              API = Api.addNewCustomer(this.dataSubmit);

          //EDIT CUSTOMER
          } else {
              API = Api.editCustomer(this.customerId, this.dataSubmit);
          }
          API.then((response) => {
            let success = (response.data && response.data.success && response.data.success.message)?response.data.success.message:null;
            let error = response.data.error;
            if (!response.data) {
                this.apiResponseError = 'Some thing went wrong please try again';
              $.notify('Some thing went wrong please try again', 'error');
              this.loading = false;
            } else if (error) {
                this.apiResponseError = error;
              $.notify(error, 'error');
              this.loading = false;
            } else if (success) {
                 if (window.location.pathname === '/booking/add' || window.location.pathname === '/inquiry/add'
                     || window.location.pathname.includes("/booking-edit") || window.location.pathname.includes("/booking/view/")   ||  window.location.pathname.includes("/inquiry/view/")
                     ||  window.location.pathname.includes("/estimate/view/")   ||  window.location.pathname.includes("/invoice/view/")  )
                 {

                     EventBus.$emit('newCustomerAdded', response.data.success.id);
                  this.closeModal();
                } else if (window.location.pathname.match(/[\/^inquiry booking estimates customers invoices\w]/g)) {
                    window.location.reload(true);
                } else {
                    window.location.href = `/customer/view/${response.data.success.id}`;
                }
            }
            this.loading = false;
            $("#" + this.id).animate({scrollTop: 0}, 'slow');
        });
      }
    },
    toggleNotesField() {
        this.showNotesField = !this.showNotesField;
    },
      onAddressChanged() {
          const locationData = getCustomerLocationData(); // Invoke the function to get the data
          this.dataSubmit.locationData = locationData;
      },
  },
  created() {
    this.reBuildForm();
    this.isLoading = false;
  },
  mounted() {
      window.onAddressChanged = this.onAddressChanged;
      this.watchAddedAddressId('#customer-autocomplete-popup');
        let popupId = this.id;
        let vm = this;
        $('#' + popupId).on("shown.bs.modal", function () {
            $(this).css('overflow-y', 'scroll');
            vm.reBuildForm();
            vm.$refs.form.reset();
            vm.dataSubmit.tradingName = null;
            // vm.dataSubmit.timeZone = vm.apis.constrains.countryTimeZone || null;
        });
        $('#' + popupId).on("hidden.bs.modal", function () {
            vm.customerId = null;
            $('#country_code_from_customer').remove();
        });

      this.watchAddedAddressId('#customer-autocomplete-popup');
        EventBus.$on('onTradingNameChanged',  (value) => {
            value = value ? value.trading_name_id : null;
            vm.dataSubmit.tradingName = value;
        });
        EventBus.$on('onCountryChanged',  (value) => {
            this.countryCode = value;
            // Create a hidden input element
            $('#country_code_from_customer').remove();
            let hiddenInput = document.createElement("input");

            // Set attributes for the input element
            hiddenInput.setAttribute("type", "hidden");
            hiddenInput.setAttribute("id", "country_code_from_customer");
            hiddenInput.setAttribute("name", "country_code_from_customer");
            hiddenInput.setAttribute("value", this.countryCode);

            // Append the input element to the document body or any desired parent element
            document.body.appendChild(hiddenInput);
            // value = value ? value.trading_name_id : null;
            // vm.dataSubmit.tradingName = value;
        });

        // EventBus.$on('onTimezoneChanged',  (value) => {
        //   this.dataSubmit.timeZone = value;
        //     // vm.dataSubmit.timeZone = value;
        // });
        EventBus.$on('setCustomerId', (data) => {
          this.customerId = data;
        });
        $('form').on('focus', 'input[type=number]', function (e) {
            $(this).on('wheel.disableScroll', function (e) {
                e.preventDefault()
            })
        });
        $('form').on('blur', 'input[type=number]', function (e) {
              $(this).off('wheel.disableScroll')
        });
  },
  watch:{
    dataSubmit(){
      this.selectBusinessType(this.dataSubmit.customerType, this.dataSubmit.customerTypeId);
    }
  }
}

</script>

<style scoped>

.create-edit-customer-popup{
    z-index: 1070;
}

.ts-wrapper .option .title {
  display: block;
}

.ts-wrapper .option .url {
  font-size: 12px;
  display: block;
  color: #a0a0a0;
}

.title-new-design {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 32px;
  color: #2E4051;
}

.modal-header.new-design {
  border-bottom: unset;
  padding-left: 27px;
  padding-right: 27px;
  padding-top: 20px;
}

.inputs-title {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  color: #2E4051;
}

.customer-type-btns .btn {
  font-weight: 600;
  padding: 16px 24px;
  font-size: 16px;
  border-radius: 10px;
  background: #FFFFFF;
  color: #0a0a0a;
  border-color: #ccc;
}

.customer-type-btns .active {
  background-color: #2E4051;
  color: #FFFFFF;
}

.input-new-design {
  width: 100% !important;
}

input:focus {
  outline: none !important;
  border: 1px solid rgb(218, 222, 226) !important;
}

.date-time-group-padding {
  padding: 15px 15px 15px 15px !important;
}

.width-100 {
  width: 100% !important;
}

.unset-width {
  width: 1% !important;
}

.datepicker {
  padding: 0px;
}

::placeholder {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #979FA8;
}

.has-error {
  border-color: #a94442 !important;
}

.modal-footer.new-design {
  border-top: unset;
}

.close-icon {
  float: right;
}

.clickable {
  cursor: pointer;
}

.error-label {
  top: 8px;
  position: relative;
}

.btn.new-design {
  border-radius: 8px;
  padding: 12px 16px;
  font-family: 'Roboto', serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  text-align: center;
  color: #FFFFFF;
}

.btn-primary.new-design {
  background: #2E4051 !important;
}

.form-control.new-design::placeholder {
  font-family: 'Roboto', serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}

.form-control.new-design {
  padding: 16px;
  border: 1px solid #E0E2E5;
  border-radius: 8px;
  box-sizing: border-box;

  height: 56px;

  font-family: 'Roboto', serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}

.figma-alert {
  margin: 15px 20px -5px;
  box-sizing: border-box;
  padding: 12px 16px;
  gap: 12px;
  height: 48px;
  background: rgba(244, 67, 54, 0.07);
  border: 1px solid #F44336;
  border-radius: 8px;

}

.figma-success-alert {
  margin: 15px 20px -5px;
  box-sizing: border-box;
  padding: 12px 16px;
  gap: 12px;
  height: 48px;
  background: rgba(244, 67, 54, 0.07);
  border: 1px solid #489c25;
  border-radius: 8px;

}

.danger-alert-text {
  color: #2E4051;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;

  position: relative;
  bottom: 4px;
  left: 8px;
}

.success-alert-text {
  color: #2E4051;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;

  position: relative;
  bottom: 4px;
  left: 8px;
}

.input-new-design {
  padding: 12px 16px !important;
  /* width: 170px !important; */
  width: 330px !important;
  height: 48px !important;
  background: rgb(255, 255, 255) !important;
  border: 1px solid rgb(234, 236, 238) !important;
  border-radius: 8px !important;
}

.closeModal {
  cursor: pointer;
}

.input-new-design{
  width: 100% !important;
}

#trading-name-container .w-100{
  width: 102% !important;
}

.modal-body{
    padding-top: 5px !important;
    padding-bottom: 0px !important;
}

.business-name-new-input {
    width: 100%;
    height: 44px;
    padding: 14px 16px;
    border-radius: 8px;
    border-width: 1px;
    border-style: solid;
    border-color: rgb(218, 222, 226);
    border-image: initial;
    background: #FFFFFF;
}

.m-top--20 {
    margin-top: -20px;
}

@media (max-width: 768px) {
    #trading-name-container .w-100{
    width: 105% !important;
  }

    .no-m-b-mobile {
        margin-bottom: 0px !important;
    }

    .modal-body{
        padding: 0px 15px 0px 15px !important;
    }

    .modal-header.new-design {
        padding-left: 15px;
        padding-right: 15px;
    }

    .mobile-p-bottom-0 {
        padding-bottom: 0px;
    }

    .mobile-p-top-0 {
        padding-top: 0px;
    }

    .mobile-p-top-15{
        padding-top: 15px;
    }

    .mobile-m-bottom-0 {
        margin-bottom: 0px;
    }

    .mobile-m-bottom--8 {
        margin-bottom: -8px;
    }

}
@media (max-width: 767px) {
    .close-x-position {
        position: relative;
        bottom: 28px;
    }
    .mobile-m-top-28 {
        margin-top: -30px;
    }
    .mobile-m-top-35 {
        margin-top: -35px;
    }
    .m-top--20 {
        margin-top: 0px;
    }
}
</style>